import { ArrowLeft } from 'lucide-react'
import { Link } from 'react-router-dom'
import Header from '../../components/Header'
import Footer from '../../components/Footer'
import './Legal.css'

export default function PrivacyPolicy() {
  return (
    <div className="legal-page">
      <Header />
      
      <main className="legal-content">
        <div className="container">
          <Link to="/" className="back-link">
            <ArrowLeft size={20} />
            Back to Home
          </Link>
          
          <div className="legal-card">
            <h1>Privacy Policy</h1>
            <p className="legal-intro">At <strong>Digital vCard</strong>, we value your privacy.</p>
            <p className="legal-date">Last updated: December 2024</p>
            
            <section className="legal-section">
              <h2>1. Information We Collect</h2>
              <p>
                We may collect basic details such as your name, email, and phone number 
                when you contact us or request a service.
              </p>
            </section>
            
            <section className="legal-section">
              <h2>2. How We Use Your Information</h2>
              <p>
                We use your information only to provide our services and communicate with you. 
                Your data helps us:
              </p>
              <ul>
                <li>Process and deliver your digital vCard</li>
                <li>Provide customer support</li>
                <li>Send important service updates</li>
                <li>Improve our platform experience</li>
              </ul>
            </section>
            
            <section className="legal-section">
              <h2>3. Data Protection</h2>
              <p>
                We do not sell or share your data with third parties. Your information is 
                stored securely and protected with industry-standard encryption.
              </p>
            </section>
            
            <section className="legal-section">
              <h2>4. Cookies</h2>
              <p>
                Our website may use cookies for better functionality. These cookies help us:
              </p>
              <ul>
                <li>Remember your preferences</li>
                <li>Analyze site traffic and usage</li>
                <li>Improve user experience</li>
              </ul>
              <p>
                You can disable cookies in your browser settings, though some features 
                may not work properly.
              </p>
            </section>
            
            <section className="legal-section">
              <h2>5. Contact</h2>
              <p>
                If you have privacy concerns, contact us at:
              </p>
              <ul className="contact-list">
                <li>Email: support@santhoshsharuk.me</li>
                <li>Phone: +91 81109 60489</li>
              </ul>
            </section>
          </div>
        </div>
      </main>
      
      <Footer />
    </div>
  )
}
